import type { ISEOProps } from "../types/core";

export const ProfilePageSEO: ISEOProps = {
  title: "Profile - Sugar Cribs",
  description:
    "View and manage your Sugar Cribs profile. Update your information, settings, and preferences.",
};
